module.exports = __webpack_public_path__ + "static/media/高２学年模擬店.324ad034.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/store/高２学年模擬店.png
// module id = 341
// module chunks = 10